/**
 * Read the first field-level message from a VALIDATION_ERROR body:
 * { message: "Validation failed", details: [{ path, message }] }
 */
export function getApiValidationErrorMessage(
  data: unknown,
  fallback: string
): string {
  if (!data || typeof data !== "object") return fallback;

  const record = data as {
    details?: unknown;
    message?: unknown;
    error?: unknown;
  };
  const details = record.details;
  if (Array.isArray(details) && details.length > 0) {
    const first = details[0];
    if (first && typeof first === "object") {
      const message = (first as { message?: unknown }).message;
      if (typeof message === "string" && message.trim()) {
        return message.trim();
      }
    }
  }

  if (typeof record.message === "string" && record.message.trim()) {
    return record.message.trim();
  }
  if (typeof record.error === "string" && record.error.trim()) {
    return record.error.trim();
  }
  return fallback;
}

/** User-facing message for a thrown API call (axios error or plain Error). */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err && typeof err === "object" && "response" in err) {
    const data = (err as { response?: { data?: unknown } }).response?.data;
    return getApiValidationErrorMessage(data, fallback);
  }
  if (err instanceof Error && err.message.trim()) {
    return err.message.trim();
  }
  return fallback;
}
